var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFatherHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29381",
    "data-name": "Group 29381",
    transform: "translate(-556 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(556 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_4_",
    "data-name": "svgexport-17 (4)",
    transform: "translate(573 188.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28916",
    "data-name": "Group 28916",
    transform: "translate(0 13.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49933",
    "data-name": "Path 49933",
    d: "M43.8,341.859l6.6,3.3a2.682,2.682,0,0,1,1.458,2.034l.165,1.2H32l.165-1.2a2.682,2.682,0,0,1,1.458-2.034l6.6-3.3Z",
    transform: "translate(-32 -341.859)",
    fill: "#ea9d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49934",
    "data-name": "Path 49934",
    d: "M33.622,345.161l.523-.262v3.493H32l.165-1.2A2.684,2.684,0,0,1,33.622,345.161Zm18.406,3.232H49.882V344.9l.523.262a2.684,2.684,0,0,1,1.457,2.034Zm-5.445-5.143-4.569,3.712-4.569-3.712,1.539-.769,1.242-.621H43.8l1.449.725Z",
    transform: "translate(-32 -341.86)",
    fill: "#ea9d2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49935",
    "data-name": "Path 49935",
    d: "M205.007,311.647l-.715-.358v-1.431h-3.576v1.431l-.715.358,2.5,1.073Z",
    transform: "translate(-192.49 -298.152)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49936",
    "data-name": "Path 49936",
    d: "M219.576,309.86v.52l-.011.008A3.17,3.17,0,0,1,216,310.38v-.52Z",
    transform: "translate(-207.774 -298.153)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49937",
    "data-name": "Path 49937",
    d: "M219.576,309.86v.52l-.011.008A3.17,3.17,0,0,1,216,310.38v-.52Z",
    transform: "translate(-207.774 -298.153)",
    fill: "#e6af89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49938",
    "data-name": "Path 49938",
    d: "M34.146,409.86v3.493H32l.165-1.2a2.684,2.684,0,0,1,1.457-2.034Zm17.882,3.493H49.882V409.86l.523.262a2.684,2.684,0,0,1,1.457,2.034Z",
    transform: "translate(-32 -393.682)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49939",
    "data-name": "Path 49939",
    d: "M179.576,75.706a3.17,3.17,0,0,1-2.943-1.992,8.859,8.859,0,0,1-.634-3.29V67.576a3.576,3.576,0,1,1,7.153,0v2.848a8.859,8.859,0,0,1-.634,3.291A3.17,3.17,0,0,1,179.576,75.706Z",
    transform: "translate(-169.562 -63.284)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49940",
    "data-name": "Path 49940",
    d: "M273.431,168.715h-1.073a.358.358,0,1,1,0-.715h1.073a.358.358,0,1,1,0,.715Z",
    transform: "translate(-261.271 -162.635)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 0.447,
    cy: 0.447,
    rx: 0.447,
    ry: 0.447,
    transform: "translate(11.087 6.343)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49941",
    "data-name": "Path 49941",
    d: "M201.431,168.715h-1.073a.358.358,0,0,1,0-.715h1.073a.358.358,0,0,1,0,.715Z",
    transform: "translate(-192.49 -162.635)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 0.447,
    cy: 0.447,
    rx: 0.447,
    ry: 0.447,
    transform: "translate(8.047 6.343)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49942",
    "data-name": "Path 49942",
    d: "M241.073,219.476h-.715a.358.358,0,0,1-.358-.358v-.62a.358.358,0,0,1,.715,0v.262h.358a.358.358,0,0,1,0,.715Z",
    transform: "translate(-230.701 -210.534)",
    fill: "#e6af89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49943",
    "data-name": "Path 49943",
    d: "M145.565,173.859h-.628a.936.936,0,0,0-.936.936v.631a.936.936,0,0,0,.936.936h.673Zm6.885,0h.628a.936.936,0,0,1,.936.936v.631a.936.936,0,0,1-.936.936H152.4Z",
    transform: "translate(-138.993 -168.232)",
    fill: "#f6bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49944",
    "data-name": "Path 49944",
    d: "M147.589,56.566h.715A1.431,1.431,0,0,1,149.735,58h-3.576A1.431,1.431,0,0,1,147.589,56.566Zm3.934-2.5-.045-.18a3.336,3.336,0,0,0-1.386-1.966l-.009,0a10.044,10.044,0,0,1-3.7.718l-1.528.005a1.931,1.931,0,0,1-1.734-1.065l-.035-.069a1.9,1.9,0,0,1,.156-1.961l.026-.036a3.68,3.68,0,0,1,2.99-1.531h1.24a3.663,3.663,0,0,1,2.589,1.073h.145a1.5,1.5,0,0,1,1.341.826l.013.027a3.9,3.9,0,0,1,.3,2.693Z",
    transform: "translate(-137.933 -47.982)",
    fill: "#683b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49945",
    "data-name": "Path 49945",
    d: "M224,374.67l1.431,1.073,1.431-1.073-1.431-.811Z",
    transform: "translate(-215.417 -359.291)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49946",
    "data-name": "Path 49946",
    d: "M162.938,356.519l-4.569,3.712-4.569-3.712,1.539-.769,3.03,2.693,3.238-2.59Z",
    transform: "translate(-148.355 -341.991)",
    fill: "#c38325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49947",
    "data-name": "Path 49947",
    d: "M185.073,336l2.146,1.692-2.861,2.242L184,336.977Zm4.292,0-2.146,1.692,2.861,2.242.358-2.957Z",
    transform: "translate(-177.205 -323.124)",
    fill: "#eaeae8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatherHighlighted);
export default __webpack_public_path__ + "static/media/FatherHighlighted.8ca5a21f6b38335950817e45dc00dbfa.svg";
export { ForwardRef as ReactComponent };